import React, { FC } from 'react';
import { useMintState } from '@app/state/mintStore';
import { Address } from '@thirdweb-dev/sdk';
import { AddLiquidityBySteer } from '@app/screens/liquidity/AddLiquidityV3/components/AddLiquidityBySteer';
import { Currency } from '@cryptoalgebra/kim-sdk';
import { AddLiquidityByIchi } from '@app/screens/liquidity/AddLiquidityV3/components/AddLiquidityByIchi';
import { AddLiquidityManual } from '@app/screens/liquidity/AddLiquidityV3/components/AddLiquidityManual';

interface Props {
  poolAddress: Address | undefined;
  currencyA: Currency | undefined;
  currencyB: Currency | undefined;
}

export const AddLiquidityByProvider: FC<Props> = ({
  poolAddress,
  currencyA,
  currencyB
}) => {
  const {
    actions: { setProvider },
    provider,
    mode
  } = useMintState();

  if (mode === 'manual') {
    return (
      <AddLiquidityManual
        poolAddress={poolAddress}
        currencyA={currencyA}
        currencyB={currencyB}
      />
    );
  }

  if (provider === 'ichi' && currencyA && currencyB && poolAddress) {
    return (
      <AddLiquidityByIchi
        poolAddress={poolAddress}
        currencyA={currencyA}
        currencyB={currencyB}
      />
    );
  }

  if (provider === 'steer') {
    return (
      <AddLiquidityBySteer
        poolAddress={poolAddress}
        currencyA={currencyA}
        currencyB={currencyB}
      />
    );
  }

  return null;
};
